module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_3016.d7ea3390.png";